import { store } from '@/store'

//  Define the location of our sound media
const baseUrl = `${process.env.VUE_APP_URL_BASE}/media/sounds`

//  Download our media into a selector object
const switchObj = {
    chime: new Audio(`${baseUrl}/chime_bell_ding.wav`),
    swipe: new Audio(`${baseUrl}/swipe.wav`),
    inboundDing: new Audio(`${baseUrl}/inboundDing.wav`)
};

export default {
    play (name: string): void {
        //  Console log in debug mode
        store.getters.appDebug && console.log('SOUND:', name)

        //  Play the sound
        switchObj[name].play().catch((e) => {
            console.error('SOUND ERROR: ', e)
            console.error('Sounds are disabled in this browser.')
        });
    }
}
